class ProgressBar{
    constructor(el) {
        this.scope = el;
        this.scope.progressBar = this;
        this.bar = el.querySelector("[data-bar]");
    }

    update(value){
        this.bar.style.width = `${value}%`;
    }
}

ControlBinders.register(`[data-progress-bar]`, el => new ProgressBar(el));